import { Box, Typography } from "@mui/material";
import React, { useContext } from "react";
import { GlobalStates } from "../../../../GlobalStates";
import { useTranslation } from "react-i18next";

export const Dropdown = React.memo(({ klausimas, atsakymai }) => {
  const { user } = useContext(GlobalStates);
  const { t } = useTranslation();
  
  // Get answer based on user role
  const answer = React.useMemo(() => {
    if (!atsakymai?.length) return null;

    // If not admin, filter by user's company
    if (user?.role?.type !== "admin") {
      const userAnswer = atsakymai.find(ans => ans?.attributes?.user?.data?.id === user?.id);
      return userAnswer?.[klausimas.name] || 
             userAnswer?.attributes?.atsakymai?.[klausimas.name] ||
             userAnswer?.atsakymai?.[klausimas.name];
    }

    // For admin, show first answer (since dropdown has only one answer per company)
    const firstAnswer = atsakymai[0];
    return firstAnswer?.[klausimas.name] || 
           firstAnswer?.attributes?.atsakymai?.[klausimas.name] ||
           firstAnswer?.atsakymai?.[klausimas.name];
  }, [atsakymai, klausimas, user]);

  if (!answer) return null;

  return (
    <Box sx={{ 
      width: "100%", 
      p: 3,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start"
    }}>
      <Typography
        variant="subtitle1"
        sx={{
          color: "text.secondary",
          mb: 1,
          fontWeight: 500
        }}
      >
        {t("atsakymas")}:
      </Typography>
      <Box
        sx={{
          backgroundColor: "background.paper",
          borderRadius: 1,
          p: 2,
          width: "100%",
          maxWidth: 600,
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)"
        }}
      >
            <Typography 
              variant="body1"
              sx={{
                color: "text.primary",
                fontWeight: 400,
                lineHeight: 1.6
              }}
            >
              {t(answer, { defaultValue: answer })}
            </Typography>
      </Box>
    </Box>
  );
});
